import React, { Fragment } from 'react';

import { Theme } from '@interfaces/global';

import { Author } from '../../interfaces/authors';
import NameItem from './NameItem';

interface NameListProps {
  authors: Author[];
  theme?: Theme;
  withTooltip?: boolean;
}

const NameList = ({ authors, theme, withTooltip }: NameListProps) => {
  const authorsLength = authors.length;

  return (
    <>
      By{' '}
      {authors.map((author, index) => (
        <Fragment key={`byline-list-${index}-${author.id}`}>
          {index > 0 && index < authorsLength - 1 && ', '}
          {authorsLength > 1 && index === authorsLength - 1 && ' and '}
          <NameItem author={author} theme={theme} withTooltip={withTooltip} />
        </Fragment>
      ))}
    </>
  );
};

export default NameList;
